export default {

  data () {
    return this.$store.state.pkg
  }
}



// WEBPACK FOOTER //
// ./client/components/layout/footer/script.js